<template lang="pug">
.pagenavi
  template(v-if="current === 'motiongraphics' || current === 'videographer'")
    ul.pagenavi-inner
      li
        a(v-scroll-to="'#feature'")
          span.pc
            | スクールの特徴
          span.sp
            | 特徴
      li.sp
        a(v-scroll-to="'#portfolio'")
          | 受講生の作品
      li
        a(v-scroll-to="'#voice'")
          | 受講生の声
      li
        a(v-scroll-to="'#plan'")
          | プラン / 料金
      li
        a(v-scroll-to="'#flow'")
          span.pc
            | 受講までの流れ
          span.sp
            | 流れ
      li.sp
        a(v-scroll-to="'#faq'")
          | よくあるご質問
      li.theme-cv(v-if="current === 'motiongraphics'")
        a.external_link#school_mgc_individual_reservation(href="https://forms.vook.vc/vook/form/Untitled7/formperma/j_ZUYsupouuLJMCAAmMyFKrnWMSRPQphIUxLVCF9N6U" target="_blank")
          | オンライン相談会を予約する
    .sp-onlinebutton(v-if="current === 'motiongraphics'")
      a.external_link#school_mgc_individual_reservation(href="https://forms.vook.vc/vook/form/Untitled7/formperma/j_ZUYsupouuLJMCAAmMyFKrnWMSRPQphIUxLVCF9N6U" target="_blank")
        | オンライン相談会を予約する
  template(v-if="current === 'videographer-online'")
    ul.pagenavi-inner
      li
        a(v-scroll-to="'#feature'")
          span.pc
            | スクールの特徴
          span.sp
            | 特徴
      li
        a(v-scroll-to="'#plan'")
          | コースの概要
      li
        a(v-scroll-to="'#flow'")
          span.pc
            | 受講までの流れ
          span.sp
            | 流れ
      li
        a(v-scroll-to="'#faq'")
          | よくあるご質問
      li.theme-cv
        a.external_link#school_vgo_registration_top(href="/registration/videographer-online/entry" target="_blank")
          | お申し込みはこちら
    .sp-onlinebutton
      a.external_link#school_vgo_registration_top(href="/registration/videographer-online/entry" target="_blank")
        | お申し込みはこちら
</template>

<script>
export default {
  props: {
    current: {
      type: String,
      required: true,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/individual/school/school2023.scss';
@import '~/assets/css/individual/school/plan.scss';
$gradation-text-start: #475cb8;
$gradation-text-end: #5cc9dc;
::v-deep {
  @import '~/assets/css/individual/school/school2023-hooper.scss';
}
.pagenavi {
  position: sticky;
  top: 0;
  z-index: 15;
  .pagenavi-inner {
    display: flex;
    background-color: #000000;
    justify-content: flex-end;
    @include media(pc) {
      padding: 10px 0;
    }
    li {
      @include media(pc) {
        margin-right: 40px;
        display: block;
      }
      @include media(sp) {
        text-align: center;
        width: 25%;
        border-right: 1px solid #838383;
      }
      &.theme-cv {
        margin-right: 20px;
        @include media(sp) {
          display: none;
          border-right: none;
        }
        a {
          font-size: 14px;
          font-weight: 600;
          padding: 0 26px;
          border-radius: 50px;
          text-decoration: none;
          background: linear-gradient(
            to right,
            #db225b 0%,
            #db4521 50%,
            #dd2162 100%
          );
          &:hover {
            filter: brightness(80%);
            box-shadow: 0 0 10px 0 rgba(#000000, 0.2);
            transform: translate3d(0, 1px, 0);
          }
        }
      }
      a {
        color: #ffffff;
        font-size: 16px;
        line-height: 50px;
        @include media(sp) {
          font-size: 13px;
          line-height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 40px;
        }
        .pc {
          @include media(sp) {
            display: none;
          }
        }
        .sp {
          @include media(pc) {
            display: none;
          }
          @include media(sp) {
            display: block;
          }
        }
      }
    }
    .sp {
      @include media(sp) {
        display: none;
      }
    }
  }
}
.sp-onlinebutton {
  @include media(pc) {
    display: none;
  }
  @include media(sp) {
    display: block;
    background-color: #000000;
    text-align: center;
    padding: 10px;
    position: fixed;
    bottom: 0;
    z-index: 20;
    width: 100%;
    a {
      text-decoration: none;
      font-size: 12px;
      font-weight: 600;
      color: #ffffff;
      padding: 8px 26px;
      border-radius: 50px;
      background: linear-gradient(
        to right,
        #db225b 0%,
        #db4521 50%,
        #dd2162 100%
      );
    }
  }
}
</style>
